import { useContext, useMemo } from 'react';
import MetricsContext from 'contexts/MetricsContext';
import DatasetDefinitionsContext from 'contexts/DatasetDefinitionsContext';
import getIsNormalMetricDuplicate from 'utils/metrics/getIsNormalMetricDuplicate';

const useDuplicationWarning = ({
  metricDraft,
}: {
  metricDraft: Metrics.NormalMetric | undefined;
}) => {
  const { datasets } = useContext(DatasetDefinitionsContext);
  const { allMetrics } = useContext(MetricsContext);

  const duplicates = useMemo((): Metrics.NormalMetric[] => {
    if (!metricDraft) {
      return [];
    }

    return allMetrics
      .filter((metric) => metric.id !== metricDraft.id)
      .filter((metric) => metric.status !== 'archived')
      .filter((metric) =>
        getIsNormalMetricDuplicate({ a: metricDraft, b: metric, datasets }),
      );
  }, [allMetrics, datasets, metricDraft]);

  return {
    hasDuplicates: duplicates.length > 0,
    duplicates,
  };
};

export default useDuplicationWarning;
